(function (algolia, getDynamicPrices, addPriceInputs) {
  const client = algolia.externals.algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key
  );
  const index = client.initIndex(algolia.config.index_prefix + 'products');


  /**
   * Replace static prices on the product compare page with dynamic prices depending on the customer role.
   */
  class DiscountPricesProductsCompare {
    compareAppEl = null;
    selectors = {
      root: '#SP_CmpHtml', // compare app root
      item: '.sp_product_con', // item container
      close: '.sp_product_con .sp_close', // close/delete link, it contains variant id
      price: '.money', // price container

      // NOTE: typo is ok in the classname.
      // It won't work if the type in the class name is fixed by the app's owner
      child: '.container-fulid', // compare app first child, for mutation observer
      form: '.sp_add_to_cart form'
    };
    variants = {};
    emptyColumns = [];

    addPriceInputs = (form, variant) => void (form, variant);

    constructor(selectors, addPriceInputs) {
      this.selectors = {
        ...this.selectors,
        ...selectors
      };
      this.addPriceInputs = addPriceInputs;
      this.compareAppEl = document.querySelector(this.selectors.root);
      if (!this.compareAppEl) {
        return;
      }

      this.waitCompareTableRendering();
    }

    init = async () => {
      this.setDataFromHTML();
      await this.setVariantsData();
      this.refreshVariants();
      this.addProductColumnObserver();
    }

    clear = () => {
      this.variants = {};
      this.emptyColumns = [];
    }

    updateVariant(id, values) {
      this.variants[id] = {
        ...this.variants[id],
        ...values
      }
    }

    /**
     * Get elements, variant id from the table markup.
     */
    setDataFromHTML() {
      // product columns
      const productEls = this.compareAppEl.querySelectorAll(this.selectors.item);
      for (const productEl of productEls) {
        // close button element has an attribute with variant id
        const closeEl = productEl.querySelector(this.selectors.close);
        if (closeEl) {
          const id = closeEl.getAttribute('spcmp_vid');
          const priceEl = productEl.querySelector(this.selectors.price);
          const formEl = this.selectors.form ?
            productEl.querySelector(this.selectors.form) :
            null;

          this.updateVariant(id, {
            el: productEl,
            priceEl,
            formEl,
          });
        } else {
          this.emptyColumns.push(productEl);
        }
      }
    }

    async setVariantsData() {
      const { results } = await index.getObjects(Object.keys(this.variants));
      for (const result of results) {
        this.updateVariant(result.objectID, result);
      }
    }

    /**
     * Update variants on the page.
     */
    refreshVariants() {
      for (const variant of Object.values(this.variants)) {
        const [price, discountPrice, discount] = getDynamicPrices(variant, {
          noRange: true
        });

        if (discountPrice) {
          this.renderPrice(variant.priceEl, price, discountPrice, discount);
        }

        const form = variant.formEl;
        if (form) {
          this.addPriceInputs(form, variant);
        }
      }
    }

    renderPrice(el, price, discountPrice, discount) {
      el.innerHTML = `<div class="cmp-price">
          <span class="cmp-price__full">${price}</span>
          <span class="cmp-price__price-cnt">
              <span class="cmp-price__price">${discountPrice}</span>
              <span class="cmp-price__discount">${discount}</span>
          </span>
      </div>`;
    }
    
    addProductColumnObserver() {
      for (const column of Object.values(this.emptyColumns)) {
        const config = { childList: true };

        const callback = mutationsList => {
          const title = mutationsList[mutationsList.length - 1].addedNodes[1];
          if (title) {
            this.clear();
            this.init();
          }
        };

        const observer = new MutationObserver(callback);
        observer.observe(column, config);
      }
    }

    waitCompareTableRendering() {
      const config = { childList: true };

      const callback = mutationsList => {
        for (const mutation of mutationsList) {
          const removedNode = mutation.removedNodes[0];
          if (removedNode && removedNode.classList.contains(this.selectors.child.replace('.', ''))) {
            this.clear();
          }

          const addedNode = mutation.addedNodes[0];
          if (addedNode && addedNode.classList.contains(this.selectors.child.replace('.', ''))) {
            this.init();
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(this.compareAppEl, config);
    }
  }


  try {
    window.addEventListener('DOMContentLoaded', () => {
      window.DiscountPricesProductsCompare = new DiscountPricesProductsCompare({}, addPriceInputs);

      window.DiscountPricesProductsCompare = new DiscountPricesProductsCompare({
        root: '#sa_ca_wrapper',
        item: '.sa_ca_item',
        close: '.sa_ca_item .sa_ca_idelete',
        price: '.money',
        child: '.sa_ca_container',
        form: ''
      }, addPriceInputs);
    });
  } catch (err) {
      console.error(err);
  }
})(window.algoliaShopify, window.getDynamicPrices, window.addPriceInputs);
